import { render } from "./DcaOrders.vue?vue&type=template&id=623727ec&scoped=true"
import script from "./DcaOrders.vue?vue&type=script&lang=js"
export * from "./DcaOrders.vue?vue&type=script&lang=js"

import "./DcaOrders.vue?vue&type=style&index=0&id=623727ec&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623727ec"],['__file',"resources/js/components/DcaOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "623727ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('623727ec', __exports__)) {
    api.reload('623727ec', __exports__)
  }
  
  module.hot.accept("./DcaOrders.vue?vue&type=template&id=623727ec&scoped=true", () => {
    api.rerender('623727ec', render)
  })

}


export default __exports__